import { infiniteQueryOptions } from '@tanstack/react-query'
import { queryKeys } from '../keys'
import type {
  InfiniteData,
  UnusedSkipTokenInfiniteOptions,
} from '@tanstack/react-query'
import type { PaginationWithSearchQueryParam } from '@/types/shared'
import type { GetFleetsResponse } from '@/types/fleet'
import type { HTTPError } from 'ky'
import type { HttpErrorResponse } from '@/types/error'
import { fleetService } from '@/services'
import { INITIAL_PER_PAGE } from '@/utils/constant'

export const getFleetsQueryOptions = (
  params?: Pick<PaginationWithSearchQueryParam, 'search'>,
  options?: Omit<
    UnusedSkipTokenInfiniteOptions<
      GetFleetsResponse,
      HTTPError<HttpErrorResponse>,
      InfiniteData<GetFleetsResponse, unknown>,
      ReturnType<typeof queryKeys.fleet.list>,
      number
    >,
    'queryKey' | 'queryFn' | 'initialPageParam' | 'getNextPageParam' | 'select'
  >,
) =>
  infiniteQueryOptions({
    initialPageParam: 1,
    queryKey: queryKeys.fleet.list(params),
    queryFn: ({ pageParam }) =>
      fleetService.fleets({
        searchParams: {
          ...params,
          page: pageParam,
          per_page: INITIAL_PER_PAGE,
        },
      }),
    getNextPageParam: (lastPage) => lastPage?.meta?.next_page,
    ...options,
  })
